"use strict";

module.exports = {
  useREDIFrame: false
};



// WEBPACK FOOTER //
// ./app/infrastructure/openFinWebClientFeatures.js